import { loadStripe } from "@stripe/stripe-js";

// One Stripe.js instance for the whole app. The publishable key comes from REACT_APP_STRIPE_PUBLISHABLE_KEY (pipaan-react/.env,
// restart the dev server after changing it). It has to belong to the same Stripe account as STRIPE_SECRET in the node .env.
// There is no fallback key on purpose: a missing key is reported here instead of silently using another account.
let promise = null;

export function getStripe() {
  if (!promise) {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      console.error("REACT_APP_STRIPE_PUBLISHABLE_KEY is not set: card payment fields will not load.");
      promise = Promise.resolve(null);
    } else {
      promise = loadStripe(key);
    }
  }
  return promise;
}
